<template>
  <el-dialog
      v-dialogDrag
      title="新增功能"
      :visible="visible"
      width="60%"
      @open="open"
      @close="close"
      :close-on-click-modal="false"
  >
    <el-form
        v-loading="loading"
        element-loading-text="请稍候..."
        label-width="100px"
        class="operation"
        :model="form"
        ref="form"
        :rules="rules"
    >
      <el-row>
        <el-col :xs="8" :sm="12">
          <el-form-item label="功能名称" prop="chName">
            <el-input
                type="text"
                size="medium"
                v-model="form.chName"
                placeholder="请输入功能名称"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="功能url" prop="url">
            <el-input
                type="text"
                size="medium"
                v-model="form.url"
                placeholder="请输入功能url"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="功能类型" prop="type">
            <el-select v-model="form.type" clearable placeholder="请选择">
              <el-option
                  size="medium"
                  v-for="key in typeOptions.keys()"
                  :key="key"
                  :label="typeOptions.get(key)"
                  :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="是否启用" prop="enabled">
            <el-select v-model="form.enabled" clearable placeholder="请选择">
              <el-option
                  size="medium"
                  v-for="key in enabledOptions.keys()"
                  :key="key"
                  :label="enabledOptions.get(key)"
                  :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="上级功能" prop="parentId">
            <el-input
                type="text"
                size="medium"
                v-model="form.parentId"
                placeholder=""
            />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="12">
          <el-form-item label="备注" prop="remark">
            <el-input
                type="text"
                size="medium"
                v-model="form.remark"
                placeholder="请输入备注"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="22" class="text-right">
          <el-button size="medium" @click="close" type="default"
          >取消
          </el-button
          >
          <el-button size="medium" @click="submitForm('form')" type="primary"
          >保存
          </el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import optionVal from "@/components/mixins/optionVal";
import dialog from "@/components/mixins/dialog";
import {addFunctionInfo} from "./api/index";

export default {
  mixins: [dialog, optionVal],
  data() {
    return {
      form: {
        chName: "",
        url: "",
        type: "",
        enabled: "",
        parentId: "",
        remark: "",
      },
      rules: {
        chName: [
          {required: true, message: '请输入功能名称', trigger: 'blur'},
        ],
        url: [
          {required: true, message: '请输入功能url', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择功能类型', trigger: 'blur'},
        ],
        enabled: [
          {required: true, message: '请选择功能是否开启', trigger: 'blur'},
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = Object.assign({}, this.form);
          data.chName = this.form.chName;
          data.url = this.form.url;
          data.type = this.form.type;
          data.enabled = this.form.enabled;
          data.parentId = this.form.parentId;
          data.remark = this.form.remark;

          addFunctionInfo(data)
              .then((res) => {
                if (res.data.code == 20000) {
                  this.$emit("success");
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                this.loading = false;
                this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
                  type: "error",
                });
              });
        }
      });
    },
    open(name = "form") {
      //打开对话框先清除上次残留数据
      if (this.$refs[name]) {
        this.$refs[name].resetFields();
        // this.$refs.editor.initValue("");
      }
    },
  },
};
</script>
<style scoped>
.text-right {
  text-align: right;
}
</style>


